import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=81490ade&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=81490ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81490ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81490ade')) {
      api.createRecord('81490ade', component.options)
    } else {
      api.reload('81490ade', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=81490ade&scoped=true&", function () {
      api.rerender('81490ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85s25qlC5ou5P/JS/comp/GuestBox.vue"
export default component.exports